<div
    *ngIf="referralCode"
    class="referral-banner"
    [ngClass]="{
        'referral-banner--bunq': referralProgram === 'BUNQ',
        'referral-banner--sungevity': referralCode === 'sungevity-rijden-op-de-zon'
    }"
>
    <img *ngIf="referralProgram === 'BUNQ'" src="assets/images/referral/bunq.png" alt="" />
    <img *ngIf="referralCode === 'sungevity-rijden-op-de-zon'" src="assets/images/referral/sungevity.svg" alt="" />
    <div>
        <h2 i18n="@@configurator.welcome.referral-heading">Congratulations!</h2>
        <p
            *ngIf="['DEFAULT', 'MISSGREEN'].includes(referralProgram) && referralCode !== 'sungevity-rijden-op-de-zon'"
            i18n="@@configurator.welcome.referral-text-default"
        >
            You're currently making use of the referral code {{ referralCode }}.
        </p>
        <p *ngIf="referralProgram === 'BUNQ'" i18n="@@configurator.welcome.referral-text-bunq">
            You're making use of bunq's referral code.
        </p>
        <p *ngIf="referralCode === 'sungevity-rijden-op-de-zon'" i18n="@@configurator.welcome.referral-text-sungevity">
            You're making use of Sungevity's referral code.
        </p>
    </div>
</div>
